import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import LockIcon from "@mui/icons-material/Lock";
import CreditCardIcon from "@mui/icons-material/CreditCard";

export default function LoaderOverlay({ open }: { open: boolean }) {
  return (
    <Backdrop
      sx={{
        color: "#333",
        zIndex: (theme) => theme.zIndex.drawer + 9999,
        background: "#ffffff",
        flexDirection: "column",
        textAlign: "center",
        p: 4,
      }}
      open={open}
    >
      {/* Animated lock icon */}
      <LockIcon
        sx={{
          fontSize: 70,
          mb: 2,
          animation: "pulse 1.5s infinite",
          color: "#1E88E5",
        }}
      />

      {/* Spinner with glow */}
      <CircularProgress
        size={70}
        sx={{
          color: "#1E88E5",
          filter: "drop-shadow(0 0 6px rgba(30,136,229,0.4))",
          mb: 3,
        }}
      />

      {/* Main message */}
      <Typography
        variant="h5"
        sx={{
          fontWeight: "bold",
          mb: 1,
          color: "#1E88E5",
        }}
      >
        Secure Payment in Progress
      </Typography>

      <Typography
        variant="body1"
        sx={{
          mb: 4,
          color: "#555",
        }}
      >
        🔒 Please do not refresh or go back until the transaction completes.
      </Typography>

      {/* Extra reassurance */}
      <div style={{ display: "flex", alignItems: "center", gap: "8px", color: "#777" }}>
        <CreditCardIcon sx={{ color: "#1E88E5" }} />
        <Typography variant="body2">Powered by Growniverse</Typography>
      </div>

      {/* Subtle animations */}
      <style>
        {`
          @keyframes pulse {
            0% { transform: scale(1); opacity: 0.7; }
            50% { transform: scale(1.1); opacity: 1; }
            100% { transform: scale(1); opacity: 0.7; }
          }
        `}
      </style>
    </Backdrop>
  );
}
